// extracted by mini-css-extract-plugin
module.exports = {"root":"Footer_root__1rhnA","buttons":"Footer_buttons__16rtV"};